import { css } from '@emotion/css';

import { BaseStyle, BorderRadius, Color, Font, FontWeight, SpaceSize, Spacing, TextAlign } from '../../../styles';

export const button = ({ isDirty }: { isDirty: boolean }) => css`
  ${Spacing.p8}
  ${TextAlign.center}
  ${BaseStyle.level}
  width: fit-content !important;
  height: ${SpaceSize.is48} !important;
  ${Font.sm}
  ${FontWeight.normal}
  ${BorderRadius.xs}
  border: 1px solid ${isDirty ? Color.Brand6 : Color.Gray7} !important;
  color: ${isDirty ? Color.Brand6 : Color.Gray7} !important;

  &:focus {
    color: ${Color.Brand6} !important;
    border-color: ${Color.Brand6} !important;
  }

  &:hover:not(:focus) {
    color: ${Color.Brand6} !important;
    border-color: ${Color.Brand6} !important;
  }
`;

export const cardContent = css`
  max-width: 358px;
  min-width: 200px !important;
  width: auto;
  ${Spacing.p16}
  background: ${Color.Gray1};
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.35);
  ${BorderRadius.xs}
  .ant-card-body {
    ${Spacing.p0}
  }
`;
